// BE invalid_fields key → FamilyContactForm field name. Used to translate an
// API field error into the form's inline error map (text fields) and to look up
// titles for the summary toast.
export const FAMILY_BE_TO_FORM_FIELD: Record<string, string> = {
  name_first: 'nameFirst',
  name_last: 'nameLast',
  email: 'email',
  phone_number: 'phone',
  relationship_type_id: 'relationship',
  is_primary: 'isPrimary',
}

// BE invalid_fields key → human title for the summary toast.
export const FAMILY_BE_TO_FIELD_TITLE: Record<string, string> = {
  name_first: 'First Name',
  name_last: 'Last Name',
  email: 'Email',
  phone_number: 'Phone Number',
  relationship_type_id: 'Relationship',
  is_primary: 'Administrative Access',
}
